import React from 'react';
import PropTypes from 'prop-types';
import clamp from 'clamp-js-main';

import { isPreviewEnabled } from '@wix/wix-vod-shared/common';
import BackgroundImage from '../background-image/background-image';
import { isFreeVideo } from '../../utils';
import getBuyRentText from '../../utils/get-buy-rent-text';
import getPlayButtonText from '../../utils/get-play-button-text';
import LiveLabel from '../live-label/live-label';

import styles from './styles.scss';

class Cover extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    videoItem: PropTypes.object,
    channelData: PropTypes.object,
    imageHost: PropTypes.string,
    iconClassName: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    posterUrl: PropTypes.string,
    title: PropTypes.string,
    canShowTitle: PropTypes.bool,
    titleClassName: PropTypes.string,
    onPlayClicked: PropTypes.func,
    onBuyClicked: PropTypes.func,
    isMobile: PropTypes.bool,
  };

  componentDidMount() {
    this.clamp();
  }

  componentDidUpdate() {
    this.clamp();
  }

  clamp() {
    if (this.titleNode) {
      clamp(this.titleNode, { clamp: 2 });
    }
  }

  shouldRenderPlayButton() {
    const { videoItem } = this.props;
    return isFreeVideo(videoItem) || isPreviewEnabled(videoItem);
  }

  shouldRenderBuyButton() {
    const { videoItem } = this.props;
    return !isFreeVideo(videoItem);
  }

  renderPlayButton() {
    const { onPlayClicked, videoItem, iconClassName } = this.props;

    const text = getPlayButtonText(videoItem);

    return (
      text && (
        <button
          tabIndex="0"
          onClick={onPlayClicked}
          title={text}
          data-hook="play-button"
        >
          <span className={styles.button}>
            <span
              className={`${styles.icon} ${styles['play-icon']} ${iconClassName}`}
            />
            <span className={styles['button-text']}>{text}</span>
          </span>
        </button>
      )
    );
  }

  renderBuyButton() {
    const { onBuyClicked, videoItem, channelData, iconClassName } = this.props;

    const text = getBuyRentText(videoItem, channelData);

    if (!text) {
      return null;
    }

    return (
      <button
        tabIndex="0"
        onClick={onBuyClicked}
        data-hook="buy-button"
        title={text}
      >
        <span className={styles.button}>
          <span
            className={`${styles.icon} ${styles['buy-icon']} ${iconClassName}`}
          />
          <span className={styles['button-text']}>{text}</span>
        </span>
      </button>
    );
  }

  renderLiveLabel() {
    const { videoItem, isMobile, title } = this.props;

    return (
      <LiveLabel
        itemType={videoItem.itemType}
        dateStartLive={videoItem.dateStartLive}
        videoTitle={title}
        isMobile={isMobile}
      />
    );
  }

  render() {
    const {
      width,
      height,
      posterUrl,
      title,
      canShowTitle,
      children,
      titleClassName,
    } = this.props;

    return (
      <BackgroundImage
        className={styles.cover}
        dataHook="background-image"
        posterUrl={posterUrl}
        width={width}
        height={height}
      >
        <div className={styles.overlayContent}>
          {canShowTitle && (
            <h1
              className={`${styles.title} ${titleClassName}`}
              data-hook="title"
              title={title}
              ref={(node) => (this.titleNode = node)}
            >
              {title}
            </h1>
          )}
          {this.renderLiveLabel()}
          <div className={styles.buttons}>
            {this.shouldRenderPlayButton() && this.renderPlayButton()}
            {this.shouldRenderBuyButton() && this.renderBuyButton()}
          </div>
          {children}
        </div>
      </BackgroundImage>
    );
  }
}

export default Cover;
